import { keyframes } from '@emotion/react';
const scrollLogoAnimation = (logoScrollSpace: number) => keyframes({
  from: {
    transform: 'translateX(0)'
  },
  to: {
    transform: `translateX(-${logoScrollSpace}px)`
  }
});
export default {
  container: (logoScrollSpace: number) => ({
    position: 'relative',
    width: '100%',
    height: '32px',
    overflow: 'hidden',
    div: {
      display: 'flex',
      flexDirection: 'row',
      width: `calc( ${logoScrollSpace}px *2)`,
      div: {
        display: 'flex',
        flexDirection: 'row',
        width: `${logoScrollSpace}px`,
        height: '32px',
        transform: 'translate3d(0, 0, 0)',
        animation: `${scrollLogoAnimation(logoScrollSpace)} 20s infinite linear`,
        img: {
          width: 'auto',
          height: '32px',
          marginRight: '40px'
        }
      }
    }
  })
};